import React, { useEffect, useState } from 'react';
import { Row, Col, CustomInput } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

import api from '../../../../api/api.js';
import functions from '../../../../functions';

const _filtros = {
    Ti: 'TITULO',
    De: 'DESCRIPCIÓN',
    Ca: 'CATEGORIAS',
    Ru: 'RUBROS',
    Li: 'LINEAS',
    Ma: 'MARCAS',
    Gr: 'GRUPOS',
    Mo: 'MODELOS',
};

const FILTROS = Array.from(Object.keys(_filtros)).map(key => ({ id: key, nombre: _filtros[key], }));

const SearchArticulos = ({ state, setState }) => {
    return (
        <ParadigmaLabeledInput
            xs={[6, 6]}
            label={"Condiciones de Busqueda de Artículos"}
            inputComponent={
                <ParadigmaAsyncSeeker
                    disabled={false}
                    multiselect={true}
                    value={state.CriterioFiltrado.match(/.{1,2}/g) ? state.CriterioFiltrado.match(/.{1,2}/g) : []}
                    onChange={(data) => {
                        let CriterioFiltrado = data ? data.map(item=>item.id).join('') : '';
                        setState({ CriterioFiltrado });
                    }}
                    optionDefault={FILTROS}
                />
            }
        />
    )
}


const GeneralesConfig = ({ state, setState }) => {
    const updateImage = (evt) => {
        evt.preventDefault();
        let node = document.getElementById("raised-button-file");
        if (node != undefined && node != null && node.files != null && node.files.length == 1) {
            const reject = (Image) => setState({ 'LogoEmpresa': Image });
            const resolve = (resizedImage) => setState({ 'LogoEmpresa': resizedImage });
            functions.resizeBase64Img(240, node.files[0]).then(resolve).catch(reject);
        }
    }

    return (
        <Row>
            <Col xs={12} xl={7}>
                <ParadigmaLabeledInput
                    xs={[4, 8]}
                    md={[3, 6]}
                    label={"Nombre de Empresa"}
                    value={state.NombreEmpresa}
                    onChange={(evt) => setState({ NombreEmpresa: evt.target.value })}
                />
                <ParadigmaLabeledInput
                    xs={[4, 8]}
                    md={[3, 6]}
                    label={"URL de Web"}
                    value={state.URLEmpresa}
                    onChange={(evt) => setState({ URLEmpresa: evt.target.value })}
                />
                <ParadigmaLabeledInput
                    xs={[4, 4]}
                    md={[3, 2]}
                    label={"Cantidad de Decimales"}
                    type="number"
                    minValue={0}
                    maxValue={4}
                    value={state.CantidadDecimales.toString()}
                    onChange={(evt) => setState({ CantidadDecimales: evt.target.value })}
                />
                <ParadigmaLabeledInput
                    xs={[4, 4]}
                    md={[3, 2]}
                    value={state.PuntoVentaAsignadoAWeb}
                    label={"Punto de Venta Asignado A Web"}
                    onChange={(evt) => setState({ PuntoVentaAsignadoAWeb: evt.target.value.replace(/\D/g, '') })}
                />

                <div className="bg-info mt-2 w-100 text-center"><small>Otros</small></div>
                <ParadigmaLabeledInput
                    xs={[6, 6]}
                    label={"Categoria por Defecto para Artículos Importados"}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            disabled={false}
                            url={api.gestion.articulos.categorias}
                            clearable={true}
                            value={state.CategoriaDefectoArticulo}
                            displayField="Nombre"
                            parameters={{ paginationEnabled: "False", sort: ["Nombre"] }}
                            onChange={(data) => setState({ CategoriaDefectoArticulo: (data ? data.id : null) })}
                        />
                    }
                />
                <SearchArticulos {...{ state, setState }} />
                <CustomInput
                    type="checkbox"
                    id={`Filtro-UsarDescripcionComoTituloDeArticulo`}
                    label="Descripción como Titulo de Articulo"
                    checked={state.UsarDescripcionComoTituloDeArticulo}
                    onClick={(evt) => {
                        evt.preventDefault();
                        setTimeout(() => setState({ UsarDescripcionComoTituloDeArticulo: !state.UsarDescripcionComoTituloDeArticulo }), 100);
                    }}
                />
                <small>Al importar artículos, la descripción del artículo sera usada como titulo del mismo.</small>

            </Col>
            <Col xs={12} xl={4} className="border bg-light rounded my-1" style={{ minHeight: "150px" }}>
                <label htmlFor="raised-button-file" className="m-0 row" title="Abrir Explorador de Archivos">
                    <div className="">
                        <img className="rounded" width="100%" src={state.LogoEmpresa} alt={`Logo ${state.NombreEmpresa}`} />
                    </div>
                </label>
                <div className="position-relative bottom-0">
                    <input type="file" accept="image/*" id="raised-button-file" name="raised-button-file" className="row"
                        onChange={evt => updateImage(evt)}
                    />
                    <small>La imagen es empleada para firmar los Emails.</small>
                </div>
            </Col>
        </Row>
    )
}

export default GeneralesConfig;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/GeneralesConfig.js